export const MediaType = {
    IMAGE: 'media_image',
    VIDEO: 'media_video',
    SOUNDCLOUD: 'media_soundcloud'
}

export const PostState = {
    ADD: 'post_add',
    EDIT: 'post_edit',
    UPLOADING: 'post_uploading'
}


// WEBPACK FOOTER //
// ./src/constants/enums.js